import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const PaymentSuccessPage = () => {
  const { refreshCredits } = useAuth();

  // Refresh user data so the new plan/credits show up immediately
  useEffect(() => {
    refreshCredits();
  }, [refreshCredits]);

  return (
    <div className="h-screen bg-gray-50 flex flex-col items-center justify-center px-4 font-sans">
      <div className="bg-white rounded-2xl shadow-lg p-8 md:p-12 max-w-md w-full text-center">
        <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-5">
          <svg className="w-8 h-8 text-green-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
          </svg>
        </div>
        <h1 className="text-2xl font-bold text-gray-900 mb-2">Payment Successful!</h1>
        <p className="text-gray-600 mb-6">
          Your subscription is now active. It's time to make some magic!
        </p>
        <Link
          to="/dashboard"
          className="inline-block w-full py-3 bg-ag-black-800 text-white rounded-full font-semibold hover:bg-ag-black-700 transition-colors"
        >
          Go to Dashboard
        </Link>
      </div>
    </div>
  );
};

export default PaymentSuccessPage;
